import { render, staticRenderFns } from "./sign-up_2024.vue?vue&type=template&id=1383f27e&scoped=true&lang=pug&"
import script from "./sign-up_2024.vue?vue&type=script&lang=js&"
export * from "./sign-up_2024.vue?vue&type=script&lang=js&"
import style0 from "./sign-up_2024.vue?vue&type=style&index=0&id=1383f27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1383f27e",
  null
  
)

export default component.exports